import axios from 'axios'
import AxiosInterceptors from '@/services/axios_interceptors'

export const BackendApi = {
  getClient () {
    if (!localStorage.getItem('api_token')) {
      throw new Error('api_token not set in local storage')
    }

    var instance = axios.create({
      baseURL: process.env.API_URL,
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('api_token') }
    })

    AxiosInterceptors.addGlobalRequestInterceptors(instance)
    AxiosInterceptors.addGlobalResponseInterceptors(instance)
    AxiosInterceptors.addUnauthorizedResponseInterceptor(instance)

    return instance
  },
  getAnonymousClient () {
    var instance = axios.create({
      baseURL: process.env.API_URL
    })

    AxiosInterceptors.addGlobalRequestInterceptors(instance)
    AxiosInterceptors.addGlobalResponseInterceptors(instance)
    return instance
  },
  get (client, uri) {
    return client.get(uri)
      .then(response => { return response })
      .catch(e => { throw e })
  }
}



// WEBPACK FOOTER //
// ./src/services/backend_api.js